import saveSectionValues from './saveSectionValues'
import sendForm from './sendForm'

export const saveSectionValuesPromise = saveSectionValues
export const sendFormPromise = sendForm
